import { Flex, Text, Image, Heading, Button, Show } from "@chakra-ui/react";
import Link from "next/link";
import safe from "@public/safe 1.png";
import train from "@public/train 1.png";
import ellieemotion from "@public/ellie_emotion 1.png";
import elliereference from "@public/ellie_reference 1.png";
import CustomAccordion from "./CustomAccordion";

const DeepModeFeatures: React.FC = () => {
  return (
    <Flex mt="50px" direction="column" px={{ base: "20px", sm: "35px", md: "40px", lg: "60px", xl: "60px", "2xl": "12%" }}>
      <Text textAlign={{ base: "start", md: "center" }} fontWeight={600} fontSize={{ base: "32px", md: "48px" }} as="h2">
        DeepMode Features
      </Text>
      <Flex mt="30px" align="center" justify="space-around">
        <Flex w={{ md: "400px" }} direction="column">
          <Show below="md-1">
            <Image maxW="320px" loading="lazy" src={train.src} alt="AI Twin" />
          </Show>
          <Heading as={"h2"} fontWeight="semibold" fontSize={{ base: "26px", md: "40px" }}>
            Create your AI Twin
          </Heading>
          <Text fontSize={{ base: "14px", md: "16px" }} mt="20px" w={{ base: "100%", xlg: "540px" }}>
            Unleash your imagination and create unique photos with unlimited freedom. Easily turn your personal photos into Lifelike AI Clones with Our User-Friendly Platform.
          </Text>
          <Link href="/train">
            <Button mt="35px" w={{ sm: "100%", md: "195px" }} color="white" bg="button.500">
              Start creating for free
            </Button>
          </Link>
        </Flex>
        <Show above="md-1">
          <Image loading="lazy" src={train.src} alt="Train AI" />
        </Show>
      </Flex>
      <Flex direction={{ base: "column", md: "row" }} mt={{ base: "50px", md: "100px" }} w="100%" align={{ base: "start", md: "center" }} justify="space-around">
        <Flex h="100%">
          <Image src={safe.src} alt="Private AI Image Generation" />
        </Flex>
        <Flex align="start" direction="column">
          <Heading as={"h2"} fontSize={{ base: "26px", md: "40px" }} fontWeight="semibold" minW="290px" lineHeight={1.1} mt="20px">
            Private AI Image Generation{" "}
          </Heading>
          <Text fontSize={{ base: "14px", md: "16px" }} mt="15px" w={{ base: "290px", lg: "540px" }}>
            Our technology safeguards your creations, offering a seamless and protected experience. Your AI generated are kept private.
          </Text>
        </Flex>
      </Flex>
      <Flex mt={{ base: "50px", md: "100px" }} w="100%" align={{ base: "start", md: "center" }} justify="space-around">
        <Flex direction="column">
          <Show below="md-1">
            <Image src={ellieemotion.src} alt="Change Facial Expressions" />
          </Show>
          <Text mt="20px" fontWeight={600} lineHeight={1.1} fontSize={{ base: "26px", md: "40px" }}>
            Change Facial Expressions
          </Text>
          <Text fontSize={{ base: "14px", md: "16px" }} maxW={{ base: "290px", lg: "540px" }} mt="15px">
            Explore the full range of human emotions with our facial expression transformation feature. Let your imagination go wild. Create a more engaging, dynamic, and relatable visuals that captures the heart.
          </Text>
        </Flex>
        <Show above="md-1">
          <Image src={ellieemotion.src} alt="Change Facial Expressions" />
        </Show>
      </Flex>
      <Flex mt={{ base: "50px", md: "100px" }} w="100%" align={{ base: "start", md: "center" }} justify="space-around">
        <Show above="md-1">
          <Image src={elliereference.src} alt="Recreate AI Art from Any Reference Image" />
        </Show>
        <Flex direction="column">
          <Show below="md-1">
            <Image src={elliereference.src} alt="Recreate AI Art from Any Reference Image" />
          </Show>
          <Text w={{ base: "290px", lg: "454px" }} fontWeight={600} lineHeight={1.1} fontSize={{ base: "26px", md: "40px" }}>
            Recreate AI Art from Any Reference Image
          </Text>
          <Text fontSize={{ base: "14px", md: "16px" }} w={{ base: "290px", lg: "454px" }} mt="15px">
            Transform your inspiration into a stunning AI Art with our powerful “Remix” feature. Simply upload any image and watch as our platform intelligently recreates it according to your prompt.
          </Text>
        </Flex>
      </Flex>
      <Flex mt="50px" direction="column" align="center">
        <Text textAlign={{ base: "start", md: "center" }} fontWeight={600} fontSize={{ base: "32px", md: "48px" }} as="h2">
          Create your AI character today
        </Text>
        <Link href="/train">
          <Button mt="35px" w={{ base: "100%", md: "195px" }} color="white" bg="button.500">
            Start creating for free
          </Button>
        </Link>
      </Flex>
      <CustomAccordion />
    </Flex>
  );
};

export default DeepModeFeatures;
